// 问董秘
// 概念、互动、关键词 top 10
import request from '@/utils/request'
import axios from 'axios'
import { stockpoolurl, apiUrl, indexPoolUrl } from './config'
// import { logicalExpression } from '@babel/types';
type dataType = any

export default {
  // 获取Token     return axios.post('https://hqpassport.sylapp.cn/api/v2/AuthGetToken', {

  getToken(): Promise<any> {
    return axios.post('https://hqpassport.sylapp.cn/api/v2/AuthGetToken', {
      "AppKey": "pc",
      "AppSecret": "befa3635-8d86-42b3-a157-637db2a52554",
      "Name": "jfztADV",
      "Desc": "九方智投",
      "Version": "3.14.1",
      "Type": "h5",
    },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
  },

  // 获取交易日
  getTradingDays(params: any, token: string): Promise<any> {
    return axios.get('https://baseinfo.sylapp.cn/tradingdays', {
      params,
      headers: {
        'Token': token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
  },

  getStockPoolList(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: stockpoolurl + '/pool/api/1/strategy/stock/pool/list',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },

  // 获取四维猎手股池数据
  getFourHunterPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/fourHunter/pool',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },



  // 获取产品配置数据
  getProductConfig(): Promise<any> {
    return axios.get(indexPoolUrl + '/helpmanual/assets/indexPool/indexPool.json')
  },

  // 获取箱体擒龙股池数据（新接口）
  getLadderPoolList(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-stock-pool/api/1/strategy/pool/ladder/list',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取筹码大师股池数据
  getChipMasterPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-fundflow/api/1/chip/pro/signal',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取盟主趋势股池数据
  getMengzhuTrendPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/mztrend/pool',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取盟主趋势近30天热门案例数据
  getMengzhuTrendCard(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/mztrend/card',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  }
}
